import React from 'react';
import { Navbar } from '../components';
import { AboutUs, Chef, FindUs, Footer, Gallery, Header, Intro, SpecialMenu } from '../container';
import Chatbot from '../components/Chatbot/Chatbot';
import Category from '../container/Category/Category';
import Menu from '../container/Menu/Menu';

import "../App.css"
const Home = () => {
    return (
        <div className="app">
            <Navbar />
            <Header />
            <Chatbot />
            <Category />
            {/* <LeftNav /> */}
            <SpecialMenu />
            {/* <RegularMenu /> */}
            <Menu />
            <AboutUs />
            <Intro />
            <Chef />
            <Gallery />
            <FindUs />
        </div>
    );
};

export default Home;